function hideModalApp() {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = `
        #image-popup-overlay { 
            display: none !important; 
            opacity: 0 !important; 
            visibility: hidden !important; 
            pointer-events: none !important;
        }
    `;
    document.head.appendChild(styleSheet);
    const observer = new MutationObserver((mutationsList, obs) => {
        const modalElement = document.querySelector("#image-popup-overlay");

        if (modalElement) {
            modalElement.style.setProperty("display", "none", "important");
            obs.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
        observer.disconnect();
    }, 10000); 
}